import { createUseData } from "../../../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./create-account-dialog.service";

export const useAccountTypes = createUseData(
    service.getAccountTypes,
)